import { ViewportContent } from '~/src/store';
import { getEnabledElementControlled } from './cornestone/getEnabledElementControlled';

export const getViewportEnabledElements = (viewportDataArray: Array<ViewportContent>) => {
  return viewportDataArray
    .filter((viewport) => Boolean(getEnabledElementControlled(viewport.dom)))
    .map((viewport) => viewport.dom);
};
